import { Button } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { NeighborAreasSettingsItemEdit } from "./neighbor-areas-settings-item-edit";
import { NeighborAreasTemplateContext } from "./neighbor-areas-template-context";

export const NeighborAreasSettingsAddItem: FC = () => {
  const { t } = useTranslation();
  const { onInnerEditStart, onInnerEditEnd } = useContext(
    NeighborAreasTemplateContext,
  );
  const [isOpenedEditForm, setIsOpenedEditForm] = useState(false);

  useEffect(() => {
    if (isOpenedEditForm) {
      onInnerEditStart();
    } else {
      onInnerEditEnd();
    }
  }, [isOpenedEditForm, onInnerEditStart, onInnerEditEnd]);
  return (
    <div className="NeighborAreasSettings-AddItem">
      {isOpenedEditForm && (
        <NeighborAreasSettingsItemEdit
          onCancelEdit={() => setIsOpenedEditForm(false)}
        />
      )}
      {!isOpenedEditForm && (
        <Button variant="text" onClick={() => setIsOpenedEditForm(true)}>
          {t("general.APPEND")}
        </Button>
      )}
    </div>
  );
};
